import React, { ReactElement } from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { QueryParamProvider } from 'use-query-params'
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6'
import { AuthProvider } from 'src/context/auth.context'
import { ToastProvider } from 'src/context/toast.context'
import CompleteEditCalculation from 'src/features/dsl/CompleteEditCalculation/pages'
import EditCalculationDSL from 'src/features/dsl/EditCalculationDSL/pages'
import EditOCRFormat from 'src/features/dsl/EditOCRFormat/pages'
import EditReadItem from 'src/features/dsl/EditReadItem/pages'
import StartEditCalculation from 'src/features/dsl/StartEditCalculation/pages'
import PagesMembersCreate from 'src/features/members/pages/Create'
import PagesMembersList from 'src/features/members/pages/List'
import Profile from 'src/features/members/pages/Profile'
import PagesMembersUpdate from 'src/features/members/pages/Update'
import StoreSalesReportSummary from 'src/features/storeSalesReportSummary/pages'
import PagesTenantOwnerCompanyCreate from 'src/features/tenantOwnerCompany/pages/Create'
import PagesTenantOwnerCompanyList from 'src/features/tenantOwnerCompany/pages/List'
import PagesTenantOwnerCompanyUpdate from 'src/features/tenantOwnerCompany/pages/Update'
import TenantSalesReport from 'src/features/tenantSalesReport/pages/TenantSalesReport'
import PagesTenantSalesReportSummary from 'src/features/tenantSalesReportSummary/pages'
import PagesTenantsOfTenantOwnerCompanyList from 'src/features/tenantsOfTenantOwnerCompany/pages/List'
import PagesTenantsOfTenantOwnerCompanyUpdate from 'src/features/tenantsOfTenantOwnerCompany/pages/Update'
import Login from 'src/pages/Login'
import LoginAction from 'src/pages/LoginAction'
import LoginSentEmail from 'src/pages/LoginSentEmail'
import Root from 'src/pages/Root'
import Store from 'src/pages/Store'
import Stores from 'src/pages/Stores'
import TenantCreate from 'src/pages/TenantCreate'
import TenantDetail from 'src/pages/TenantDetail'
import Tenants from 'src/pages/Tenants'
import TenantUpdate from 'src/pages/TenantUpdate'
import LoginRoute from './loginRoute'
import { PathTemplate } from './path'
import PrivateRoute from './privateRoute'

function AppRouter(): ReactElement {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ToastProvider>
          <QueryParamProvider adapter={ReactRouter6Adapter}>
            <Routes>
              <Route
                path="/"
                element={
                  <PrivateRoute>
                    <Root />
                  </PrivateRoute>
                }
              />
              <Route
                path={PathTemplate.login}
                element={
                  <LoginRoute>
                    <Login />
                  </LoginRoute>
                }
              />
              <Route
                path={PathTemplate.loginSentEmail}
                element={
                  <LoginRoute>
                    <LoginSentEmail />
                  </LoginRoute>
                }
              />
              <Route
                path={PathTemplate.loginAction}
                element={
                  <LoginRoute>
                    <LoginAction />
                  </LoginRoute>
                }
              />
              <Route
                path={PathTemplate.profile}
                element={
                  <PrivateRoute showSidebar>
                    <Profile />
                  </PrivateRoute>
                }
              />
              <Route
                path={PathTemplate.stores}
                element={
                  <PrivateRoute showSidebar>
                    <Stores />
                  </PrivateRoute>
                }
              />
              <Route
                path={PathTemplate.store}
                element={
                  <PrivateRoute showSidebar>
                    <Store />
                  </PrivateRoute>
                }
              />
              <Route
                path={PathTemplate.tenant}
                element={
                  <PrivateRoute showSidebar>
                    <TenantDetail />
                  </PrivateRoute>
                }
              />
              <Route
                path={PathTemplate.tenants}
                element={
                  <PrivateRoute showSidebar>
                    <Tenants />
                  </PrivateRoute>
                }
              />
              <Route
                path={PathTemplate.storeSalesReportSummaries}
                element={
                  <PrivateRoute showSidebar>
                    <StoreSalesReportSummary />
                  </PrivateRoute>
                }
              />
              <Route
                path={PathTemplate.members}
                element={
                  <PrivateRoute showSidebar>
                    <PagesMembersList />
                  </PrivateRoute>
                }
              />
              <Route
                path={PathTemplate.membersCreate}
                element={
                  <PrivateRoute>
                    <PagesMembersCreate />
                  </PrivateRoute>
                }
              />
              <Route
                path={PathTemplate.membersUpdate}
                element={
                  <PrivateRoute>
                    <PagesMembersUpdate />
                  </PrivateRoute>
                }
              />
              <Route
                path={PathTemplate.tenantSalesReportSummaries}
                element={
                  <PrivateRoute showSidebar>
                    <PagesTenantSalesReportSummary />
                  </PrivateRoute>
                }
              />
              <Route
                path={PathTemplate.tenantOwnerCompaniesUpdate}
                element={
                  <PrivateRoute>
                    <PagesTenantOwnerCompanyUpdate />
                  </PrivateRoute>
                }
              />
              <Route
                path={PathTemplate.tenantOwnerCompanies}
                element={
                  <PrivateRoute showSidebar>
                    <PagesTenantOwnerCompanyList />
                  </PrivateRoute>
                }
              />
              <Route
                path={PathTemplate.tenantOwnerCompaniesCreate}
                element={
                  <PrivateRoute>
                    <PagesTenantOwnerCompanyCreate />
                  </PrivateRoute>
                }
              />
              <Route
                path={PathTemplate.tenantsOfTenantOwnerCompanyUpdate}
                element={
                  <PrivateRoute>
                    <PagesTenantsOfTenantOwnerCompanyUpdate />
                  </PrivateRoute>
                }
              />
              <Route
                path={PathTemplate.tenantsOfTenantOwnerCompanyList}
                element={
                  <PrivateRoute showSidebar>
                    <PagesTenantsOfTenantOwnerCompanyList />
                  </PrivateRoute>
                }
              />
              <Route
                path={PathTemplate.startEditCalculation}
                element={<StartEditCalculation />}
              />
              <Route
                path={PathTemplate.createTenants}
                element={<TenantCreate />}
              />
              <Route
                path={PathTemplate.updateTenants}
                element={<TenantUpdate />}
              />
              <Route
                path={PathTemplate.editReadItem}
                element={<EditReadItem />}
              />
              <Route
                path={PathTemplate.editOCRFormat}
                element={<EditOCRFormat />}
              />
              <Route
                path={PathTemplate.editCalculationDSL}
                element={<EditCalculationDSL />}
              />
              <Route
                path={PathTemplate.completeEditCalculation}
                element={<CompleteEditCalculation />}
              />
              <Route
                path={PathTemplate.tenantSalesReport}
                element={<TenantSalesReport />}
              />
            </Routes>
          </QueryParamProvider>
        </ToastProvider>
      </AuthProvider>
    </BrowserRouter>
  )
}

export default AppRouter
